import React from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import { m } from 'framer-motion';

export const REACTION_EMOJIS = ['\u{1F44D}', '❤️', '\u{1F602}', '\u{1F62E}', '\u{1F622}', '\u{1F64F}'];

const baseButtonStyle = {
    appearance: 'none',
    border: '0',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: 22,
    lineHeight: 1,
    width: 36,
    height: 36,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    transition: 'background-color 120ms ease, box-shadow 120ms ease',
};

const EmojiReactionBar = ({ currentEmoji, onPick, onRemove, disabled = false }) => {
    const handleClick = (emoji) => {
        if (disabled) return;
        if (emoji === currentEmoji) {
            if (typeof onRemove === 'function') onRemove();
            return;
        }
        if (typeof onPick === 'function') onPick(emoji);
    };

    return (
        <Box
            role="toolbar"
            aria-label="React to message"
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.25,
                px: 0.5,
            }}
        >
            {REACTION_EMOJIS.map((emoji) => {
                const isActive = currentEmoji === emoji;
                const buttonStyle = {
                    ...baseButtonStyle,
                    backgroundColor: isActive ? 'rgba(0,171,85,0.14)' : 'transparent',
                    boxShadow: isActive ? 'inset 0 0 0 2px rgba(0,171,85,0.55)' : 'none',
                    opacity: disabled ? 0.5 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                };
                return (
                    <Tooltip key={emoji} title={isActive ? 'Remove reaction' : `React with ${emoji}`} arrow>
                        <m.button
                            type="button"
                            aria-label={isActive ? `Remove ${emoji} reaction` : `React with ${emoji}`}
                            aria-pressed={isActive}
                            disabled={disabled}
                            onClick={() => handleClick(emoji)}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault();
                                    handleClick(emoji);
                                }
                            }}
                            whileHover={disabled ? undefined : { scale: 1.18 }}
                            whileTap={disabled ? undefined : { scale: 0.92 }}
                            transition={{ duration: 0.12, ease: [0.2, 0.9, 0.3, 1] }}
                            style={buttonStyle}
                        >
                            <span aria-hidden="true">{emoji}</span>
                        </m.button>
                    </Tooltip>
                );
            })}
        </Box>
    );
};

EmojiReactionBar.propTypes = {
    currentEmoji: PropTypes.string,
    onPick: PropTypes.func,
    onRemove: PropTypes.func,
    disabled: PropTypes.bool,
};

export default EmojiReactionBar;
